export default [
  {
    name: 'Rare Wind',
    description: '#a8edea → #fed6e3',
    css: 'linear-gradient(to top, #a8edea 0%, #fed6e3 100%)',
    height: 100,
  },
  {
    name: 'Saint Petersburg',
    description: '#f5f7fa → #c3cfe2',
    css: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    height: 200,
  },
  {
    name: 'Deep Blue',
    description: '#e0c3fc → #8ec5fc',
    css: 'linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%)',
    height: 200,
  },
  {
    name: 'Ripe Malinka',
    description: '#f093fb → #f5576c',
    css: 'linear-gradient(120deg, #f093fb 0%, #f5576c 100%)',
    height: 200,
  },
  {
    name: 'Perfect White',
    description: '#fdfbfb → #ebedee',
    css: 'linear-gradient(-225deg, #E3FDF5 0%, #FFE6FA 100%)',
    height: 200,
  },
  {
    name: 'Near Moon',
    description: '#5ee7df → #b490ca',
    css: 'linear-gradient(to top, #5ee7df 0%, #b490ca 100%)',
    height: 200,
  },
  {
    name: 'Wild Apple',
    description: '#d299c2 → #fef9d7',
    css: 'linear-gradient(to top, #d299c2 0%, #fef9d7 100%)',
    height: 100,
  },
  {
    name: 'Ladoga Bottom',
    description: '#ebc0fd → #d9ded8',
    css: 'linear-gradient(to top, #ebc0fd 0%, #d9ded8 100%)',
    height: 200,
  },
  {
    name: 'Sunny Morning',
    description: '#f6d365 → #fda085',
    css: 'linear-gradient(120deg, #f6d365 0%, #fda085 100%)',
    height: 100,
  },
  {
    name: 'Lemon Gate',
    description: '#96fbc4 → #f9f586',
    css: 'linear-gradient(to top, #96fbc4 0%, #f9f586 100%)',
    height: 200,
  },
  {
    name: 'Salt Mountain',
    description: ' #FFFEFF → #D7FFFE',
    css: 'linear-gradient(-225deg, #FFFEFF 0%, #D7FFFE 100%)',
    height: 100,
  },
  {
    name: 'New York',
    description: ' #fff1eb → #ace0f9',
    css: 'linear-gradient(to top, #fff1eb 0%, #ace0f9 100%)',
    height: 200,
  },
  {
    name: 'Soft Grass',
    description: ' #c1dfc4 → #deecdd',
    css: 'linear-gradient(to top, #c1dfc4 0%, #deecdd 100%)',
    height: 200,
  },
  {
    name: 'Japan Blush',
    description: ' #ddd6f3 → #faaca8',
    css: 'linear-gradient(-20deg, #ddd6f3 0%, #faaca8 100%, #faaca8 100%)',
    height: 100,
  },
];
